/**
 * Protocol version. Bump the major when making breaking changes to the
 * postMessage protocol or the REST API; minor when adding backward-compatible
 * fields. Both host bridges and the games-web app should agree on the major.
 */
export const PROTOCOL_VERSION = '1.0.0';
export const PROTOCOL_MAJOR = 1;
//# sourceMappingURL=version.js.map